// extracted by mini-css-extract-plugin
export default {"cls1":"VeloPhoneNumberField-CountryName_cls1__CIOGx","cls2":"VeloPhoneNumberField-CountryName_cls2__M+ZMM VeloPhoneNumberField-CountryName_cls1__CIOGx"};